import React, { createContext, useContext, useState, ReactNode } from 'react'

interface SidebarContextType {
  expanded: boolean
  setExpanded: (expanded: boolean) => void
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined)

export const SidebarProvider: React.FC<{children: ReactNode}> = ({ children }) => {
  const [expanded, setExpanded] = useState<boolean>(true)

  return (
    <SidebarContext.Provider value={{ expanded, setExpanded }}>
      {children}
    </SidebarContext.Provider>
  )
}

export const useSidebar = (): SidebarContextType => {
  const context = useContext(SidebarContext)
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider')
  }
  return context
}

export const useOptionalSidebar = (): SidebarContextType | undefined => {
  return useContext(SidebarContext)
}
